import { useCallback } from "react";
import { HubConnectionState } from "@microsoft/signalr";

export default function usePortalHubActions({ connection }) {
  const invoke = useCallback((topic, ...args) => {
    if (!connection || connection.state != HubConnectionState.Connected) {
      console.warn("Invoke not available. Connection is not Connected. Topic:", topic, connection?.state, args);
      return false;
    }

    console.log(`portalhub-invoke: ${topic}`, args);
    if (args.length) {
      connection.invoke(topic, ...args);
    } else {
      connection.invoke(topic);
    }
  }, [connection]);

  const subscribe = useCallback((topic, callback, dontlog) => {
    if (connection?.state != HubConnectionState.Connected) {
      console.warn("Subscribe not available. Connection is not Connected. Topic:", topic, connection?.state);
      return;
    }
    
    connection.on(topic, callback);
    if(!dontlog){
      console.log(
        "%csubscription created for [" + topic + "]",
        "color:lightgreen"
      );
    }
  }, [connection]);

  const unsubscribe = useCallback((topic) => {
    if (!connection) {
      return;
    }

    connection.off(topic);
    console.log("%csubscription removed for [" + topic + "]", "color:orange");
  }, [connection]);

  return {
    subscribe,
    unsubscribe,
    invoke,
  };
}
